// What a session is called on screen. The renamed title (alt_name) wins;
// otherwise the immutable name, except that the old generated names read as
// a date the way the app names new sessions ("Oct 31, 3:21 PM"):
//   "🌊 21:47 10-30-2026"  (app, HH:mm MM-dd-yyyy, optional emoji prefix)
//   "maya-20261025-140247" (web GetStarted, user-yyyyMMdd-HHmmss)
// The timestamp is the creator's local time, so it is reformatted, never
// shifted.

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function fmt(year, month, day, hour, minute) {
  if (month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return null;
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  const ampm = hour < 12 ? "AM" : "PM";
  return `${MONTHS[month - 1]} ${day}, ${h12}:${String(minute).padStart(2, "0")} ${ampm}`;
}

const APP_STAMP = /^(?:\S+\s+)?(\d{2}):(\d{2}) (\d{2})-(\d{2})-(\d{4})$/u;
const WEB_STAMP = /^.+-(\d{4})(\d{2})(\d{2})-(\d{2})(\d{2})\d{2}$/;

export function prettySessionName(name) {
  const s = (name || "").trim();
  let m = APP_STAMP.exec(s);
  if (m) return fmt(+m[5], +m[3], +m[4], +m[1], +m[2]) || s;
  m = WEB_STAMP.exec(s);
  if (m) return fmt(+m[1], +m[2], +m[3], +m[4], +m[5]) || s;
  return s;
}

export function sessionTitle(session) {
  const alt = session && typeof session.alt_name === "string" ? session.alt_name.trim() : "";
  if (alt) return alt;
  return prettySessionName(session && session.name) || "Untitled";
}
